

export type NativeError = {
  code: string;
  domain: string;
  message: string;
  nativeStackIOS: string[];
};